/* eslint-disable no-unused-vars */
define(
  'nearbySectionHandler',[
    'builderShowcaseObserver',
    'ajaxHelper',
    'routes',
    'fastdom',
    'lazyLoad'
  ],
  (builderShowcaseObserver, ajaxHelper, routes, fastdom, lazyLoad) => {
    'use strict';

    const nearbySection = document.querySelector('[data-nearbySection-container]');
    let lastMarketIdShowed = 0;

    /**
   * nearby section Constructor.
   */
    function nearbySectionHandler() {
    }

    /**
     * calls lazy load init module
     * */
    function initLazyLoad() {
      if (lazyLoad) {
        lazyLoad.init();
      }
    }

    /**
     * @private
     * attaches arrows events to the comms cards when updated via ajax.
     */
    function attachArrowEvent() {
      const communityCards = document.querySelectorAll('[data-nearby-community]');

      communityCards.forEach((community) => {
        // eslint-disable-next-line no-new
        new window.NewHomeSource.Modules.ArrowHandler({
          container: community
        });
      });
    }

    /**
     * @private
     * updateContent: sets the upcoming nearby section in the DOM.
     * @param {object} html nearby section.
    */
    function updateContent(html) {
      if (!nearbySection) {
        return;
      }

      if (!html) {
        // eslint-disable-next-line no-param-reassign
        html = '';
      }

      fastdom.mutate(() => {
        nearbySection.innerHTML = html;
        attachArrowEvent();
      });

      fastdom.mutate(() => {
        initLazyLoad();
      });
    }

    /**
     * @private
     * getNearbySection: retrieves from server the nearby section based on a given market.
     * @param {int} brandId brand id.
     * @param {int} marketId market id, 0 if is national search.
    */
    function getNearbySection(brandId, marketId) {
      const baseUrl = routes.getBuilderShowCaseNearbySection;
      const url = `${baseUrl}?brandId=${brandId}&marketId=${marketId}`;

      ajaxHelper.getRequest(
        url,
        'application/json',
        null,
        {
          async: true,
          abort: true,
          success: (response) => {
            updateContent(response);
          }
        }
      );
    }

    /**
     * @private
     * getProposedMarketId: Gets the Id of the proposed market if any.
     *
     * @returns an integer indicating the market Id out of the proposedMarket
     * argument sent when executing this function.
    */
    function getProposedMarketId(proposedMarket) {
      if (!proposedMarket) {
        return 0;
      }

      return +proposedMarket.Id || 0;
    }

    /**
     * @private
     * onMarketChanged: Gets nearby comms based on the market update and update the nearby section.
    */
    function onMarketChanged() {
      const state = builderShowcaseObserver.getState();
      const proposedMarket = state.data.proposedMarket || {};

      const brandId = state.data.BrandId;
      const marketId = getProposedMarketId(proposedMarket);

      if (marketId === lastMarketIdShowed) {
        return;
      }

      lastMarketIdShowed = marketId;
      getNearbySection(brandId, marketId);
    }

    /**
     * @public
     * update: function to display the phone for those cards withput call tracking.
    */
    function displayPhone(target) {
      const callButton = target;
      const phone = target.previousElementSibling;

      if (phone && 'communityPhone' in phone.dataset) {
        fastdom.mutate(() => {
          callButton.style.display = 'none';
          phone.style.display = 'block';
          phone.focus();
        });
      }
    }

    /**
     * @public
     * update: function for handle different events from the section.
     * used as an event delegation
    */
    function handleSectionEvents(event) {
      const target = event.target;

      if ('displayPhone' in target.dataset) {
        displayPhone(target);
      }

      // add more events if needed.
    }

    /**
     * @public
     * update: function for receiving notifications about state changes.
    */
    nearbySectionHandler.update = function updateNearbySection() {
      onMarketChanged();
    };

    /**
     * Used to display more manufactured results
     */
    function showMoreManufacturedResults(event) {
      const target = event.target;

      const communityCards = document.querySelectorAll('[data-nearby-community]');

      communityCards.forEach((community) => {
        community.classList.remove('hidden');
      });

      target.dataset.open = true;
      target.textContent = target.dataset.showLessText;
      target.dataset.gaEventLabel = target.dataset.showMoreText;
    }

    /**
     * Used to display less manufactured results
     */
    function showLessManufacturedResults(event) {
      const target = event.target;
      target.removeAttribute('data-open');
      target.textContent = target.dataset.showMoreText;
      target.dataset.gaEventLabel = target.dataset.showLessText;
      let index = 0;

      const communityCards = document.querySelectorAll('[data-nearby-community]');

      communityCards.forEach((community) => {
        if (index >= 3) {
          community.classList.add('hidden');
        }
        index += 1;
      });
    }

    /**
     * @public
     * attachManufacturedShowMoreHandler: function to attach the event handler to the show more button.
     */
    function attachManufacturedShowMoreHandler() {
      const button = document.querySelector('[data-show-more-manufactured]');

      if (button) {
        button.addEventListener('click', (event) => {
          if (!button.dataset.open) {
            showMoreManufacturedResults(event);
          } else {
            showLessManufacturedResults(event);
          }
        });
      }
    }

    if (nearbySection) {
      nearbySection.addEventListener('click', handleSectionEvents);
    }

    builderShowcaseObserver.subscribe('onBeforeMapResultsLoaded', nearbySectionHandler);
    attachManufacturedShowMoreHandler();
  }
);

